import { useNavigate, useLocation } from "react-router-dom";

import { Button } from "V2.0/common/button";

import { ArrowLeftIcon } from "@heroicons/react/24/outline";

function AssistantsBackToHome(props) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="flex-none">
      <Button className="" plain onClick={() => navigate({pathname: "/assistants", search: location.search})}>
        <ArrowLeftIcon />
      </Button>
    </div>
  );
}

export default AssistantsBackToHome;
